import { get } from "http";
import { getHeaders } from "../contexts/AuthContext";

export const addProperty = async (data) => {
  const companyID = sessionStorage.getItem('company_id');

  const body = JSON.stringify({
      "companyId": companyID,
      "description": data.description,
      "name": data.name,
      "enabled": false,
      "myob": false,
      "rms": false,
      "abn": data.abn,
      "rooms": data.rooms
  })
    
  const headers = await getHeaders();
  const response = await fetch(`${import.meta.env.VITE_API_URL}/property`, { 
    mode: 'cors',
    method: 'put',
    body: body,
    headers: headers,
  })

  const responseBody = await response.json();

  if(response.status !== 200) {
    throw new Error(responseBody);
  }
  return {
    status: response.status,
    body: responseBody,
  };
};

export const fetchProperties = async () => {
  try {
    const headers = await getHeaders();
    const userId = sessionStorage.getItem('user_id');
    
    if (!userId) {
      console.error('No user ID found in session storage');
      return [];
    }
    
    const response = await fetch(`${import.meta.env.VITE_API_URL}/properties/${userId}`, {
      mode: 'cors',
      method: 'GET',  
      headers: headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json(); 
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error fetching properties:', error);
    return [];
  } 
};

//Comment: Retreive property details by ID
export const fetchPropertyById = async (propertyId:string) => {
  try {
    const headers = await getHeaders();
    const companyId = `${sessionStorage.getItem('company_id')}`;

    const body = JSON.stringify({
        "propertyID": propertyId,
        "companyID": companyId,
    })

    const queryParams = `?propertyId=${propertyId}&companyId=${companyId}`
    
    const response = await fetch(`${import.meta.env.VITE_API_URL}/property${queryParams}`, { 
      mode: 'cors',
      method: 'get',
      headers: headers,
    })

    const responseBody = await response.json();

    if(response.status !== 200) {
      throw new Error(responseBody);
    }
    return {
      status: response.status,
      body: responseBody,
    };
    //Complete retreiving the integration details after refactoring
  } catch (error) {
    console.log("Error retreiving Property", error)
  }
}

export const updateProperty = async (data) => {

  const headers = await getHeaders();
  const response = await fetch(`${import.meta.env.VITE_API_URL}/property`, {
    mode: 'cors',
    method: 'post',
    body: JSON.stringify(data),
    headers: headers,
  });

  const responseBody = await response.json();

  if (response.status !== 200) {
    throw new Error(responseBody);
  }
  return {
    status: response.status,
    body: responseBody,
  };
};

